import { render, staticRenderFns } from "./CreateCategorization.vue?vue&type=template&id=6f743fc1&scoped=true&"
import script from "./CreateCategorization.vue?vue&type=script&lang=js&"
export * from "./CreateCategorization.vue?vue&type=script&lang=js&"
import style0 from "./CreateCategorization.vue?vue&type=style&index=0&id=6f743fc1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f743fc1",
  null
  
)

export default component.exports